import { createSelector } from 'reselect'

export const getData = (state, props) => {
  return props.data
}

export const makeIsMessageSelector = () => createSelector(
  [
    getData
  ],
  (
    data
  ) =>
    data.action === 'AddCommentOnCard' ||
    data.action === 'EditCommentOnCard' ||
    data.action === 'AddBoardChatMessage' ||
    data.action === 'AddBoardChatReply' ||
    data.action === 'SendEmailFromCard'
)

export default () => {
  const isMessageSelector = makeIsMessageSelector()

  return createSelector(
    [
      isMessageSelector
    ],
    (
      isMessage
    ) => ({
      isMessage
    })
  )
}
